import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import img_banner from '../../../../assets/images/sub/img_banner.png'

const IntroAlertPopup = (props) => {
  function onClose() {
    if (document.getElementById('today-close').checked) {
      setCookie('popupFlag', 'N', 1)
    }
    props.onClose()
  }

  /**
   * 오늘하루 열지않음 쿠키 생성
   * @param {String} name
   * @param {String} value
   * @param {number} expiredays
   */
  function setCookie(name, value, expiredays) {
    var date = new Date()
    date.setDate(date.getDate() + expiredays)
    document.cookie = name + '=' + value + '; path=/; expires=' + date.toUTCString()
  }

  return (
    <>
      {/* 알림메시지 */}
      <div className="modal-overlay">
        <div className="modal notify-message">
          <div className="modal-head">
            <h2>알림메시지</h2>
          </div>
          <div className="modal-cont">
            <div className="thumb">
              <img src={img_banner} alt="정부24 전자증명서안내" />
            </div>
            <div className="btn-block center">
              <a href="#" className="btn-secondary md blue" onClick={onClose}>
                닫기
              </a>
              <a href="#" className="btn-primary md">
                전자문서지갑 전자지갑생성
              </a>
            </div>
          </div>
          <button type="button" className="modal-close" onClick={onClose}>
            창닫기
          </button>
          <div className="today-close">
            <input type="checkbox" id="today-close" />
            <em />
            <label htmlFor="today-close">오늘 하루 열지 않기</label>
          </div>
        </div>
      </div>
      {/* //알림메시지 */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const actionCreators = {}

export default connect(mapStateToProps, actionCreators)(IntroAlertPopup)
